"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/ImageSearch` instead */
export const ImageSearch = createSVGIcon(
  <>
    <path
      d="M22.5 16v4a2 2 0 0 1-2 2h-4M1.5 16v4a2 2 0 0 0 2 2h4M1.5 10.5V7a2 2 0 0 1 2-2h1.764a2 2 0 0 0 1.789-1.106l.394-.788A2 2 0 0 1 9.237 2h5.193a2 2 0 0 1 1.664.89l.812 1.22A2 2 0 0 0 18.57 5h1.93a2 2 0 0 1 2 2v3.5"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path d="M12 7.875a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z" stroke="currentColor" />
  </>,
  "ImageSearch",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
